module.exports = __webpack_public_path__ + "img/p6-p1-diaoxiang.b1dcce1a.png";